import ArticleLayout from "@/components/feature/ArticleLayout";

export default function AccessoriesArticle() {
  return <ArticleLayout slug="pandabuy-sheet-accessories-guide" />;
}